import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthDataService} from "../../services/auth-data.service";
import {letterValidator} from "../../../../validators/letter.validator";
import {digitalValidator} from "../../../../validators/digital.validators";
import {symbolValidator} from "../../../../validators/symbol.validator";

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent {
  form!: FormGroup;

  expiryToken = ''

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authDataService: AuthDataService
  ) {
  }

  ngOnInit() {
    this.initForm()

    this.expiryToken = this.activatedRoute.snapshot.queryParamMap.get('expiryToken') || ''
  }

  initForm(): void {
    this.form = new FormGroup({
      passwordFormControl: new FormControl('', [Validators.required, Validators.minLength(8), letterValidator(), digitalValidator(), symbolValidator()]),
      passwordFormControlConfirm: new FormControl('', [Validators.required]),
    })

  }

  // get passwordFormatError() {
  //   return this.form.get('passwordFormControl')?.hasError('pattern')
  // }

  get passwordRequiredError() {
    return this.form.get('passwordFormControl')?.hasError('minlength') || this.form.get('passwordFormControl')?.hasError('required')
  }

  get passwordLetterFormatError() {
    return this.form.get('passwordFormControl')?.hasError('letterNotValid')
  }

  get passwordDigitalFormatError() {
    return this.form.get('passwordFormControl')?.hasError('digitalNotValid')
  }

  get passwordSymbolFormatError() {
    return this.form.get('passwordFormControl')?.hasError('symbolNotValid')
  }


  get passwordConfirmRequiredError() {
    return this.form.get('passwordFormControlConfirm')?.hasError('required')
  }

  get passwordConfirmError() {
    return this.form.get('passwordFormControl')?.value !== this.form.get('passwordFormControlConfirm')?.value
  }


  sendForm() {
    const data: SetNewPasswordDto = {
      password: this.form.get('passwordFormControl')?.value,
      password_confirmation: this.form.get('passwordFormControlConfirm')?.value
    }
    this.authDataService.setNewPassword(this.expiryToken, data).subscribe({
      next: () => {
        this.router.navigate(['/reset-password/success'])
      }
    })

  }
}
